// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag___Yqez","checked":"Tag_checked__KuWPE","danger":"Tag_danger__wiOVC","input":"Tag_input__P_wy1"};